/* istanbul ignore file */

import { FormulaProperties } from './formula-properties';
import { EvaluatedLogicBuilder } from './logic-builder';

export class EvaluatedFieldsProperties {
    evaluatedLogicBuilder: EvaluatedLogicBuilder;
    formulaProperties: FormulaProperties;
}
